export default "__VITE_ASSET__CG1s67_5__"